import { render, staticRenderFns } from "./SwiperProductList.vue?vue&type=template&id=843e5608&scoped=true&"
import script from "./SwiperProductList.vue?vue&type=script&lang=js&"
export * from "./SwiperProductList.vue?vue&type=script&lang=js&"
import style0 from "./SwiperProductList.vue?vue&type=style&index=0&id=843e5608&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843e5608",
  null
  
)

export default component.exports